export const GET_SESSION = 'GET_SESSION'
